// Global MapLibre configuration. Run once at module load before any Map
// instance is created.
//
// MapLibre exposes a single `config` singleton with module-level globals
// like the parallel-tile cap. These are NOT per-Map-instance options and
// cannot be passed as react-map-gl props — passing them at the JSX level
// throws "Cannot add property maxParallelImageRequests, object is not
// extensible" because react-map-gl forwards unknown props onto a sealed
// options bag.
//
// We import this module for its side effect from WorldMap.tsx (or any
// other map-rendering surface) so the cap is in place before MapLibre
// loads its first tile.

import maplibregl from 'maplibre-gl';

// Cap concurrent tile fetches. Default is 16. Drop to 8 so we don't open
// 32 sockets to tile-edge on a fast pan in dev (cross-origin HTTP/1.1).
// In production with HTTP/2 multiplexing the cap matters less, but 8 is
// a safe ceiling for both worlds.
maplibregl.config.MAX_PARALLEL_IMAGE_REQUESTS = 8;
